import React from 'react';
import { format, getHours, parse } from 'date-fns';
import PropTypes from 'prop-types';

import {
  getNextDay,
  isOpeningToday,
  isOpenToday,
  isPartialHoliday
} from '../../../../shared/utils/store/store';

import './store-hours-message.scss';

function StoreHoursMessage(props) {
  const { currentTime, weekDays } = props;
  const message = {
    body: 'Open Today Until',
    intro: null,
    time: '6:00 PM'
  };

  const today = Array.isArray(weekDays) ? weekDays[0] : undefined;
  const date = parse(currentTime);
  const hour = getHours(date);
  const nextDay = getNextDay(today, weekDays);
  const storeIsOpenToday = isOpenToday(today, hour);
  const closingTime = today?.closingTime?.formattedHour;
  const openingTime = today?.openingTime?.formattedHour;

  const isSat =
    format(today?.formattedDate || '', 'dddd').toLowerCase() === 'saturday';

  if (today && nextDay) {
    if (storeIsOpenToday) {
      if (hour && isOpeningToday(hour)) {
        message.body = 'Open Today at';
        message.time = '8 AM';
      } else {
        message.body = 'Open Today Until';
        message.time = closingTime;
      }

      if (today && isPartialHoliday(today)) {
        const firstClosing = `${closingTime.split(':')[0]} ${
          closingTime.split(' ')[1]
        }`;
        const secondOpening = `${openingTime.split(':')[0]} ${
          openingTime.split(' ')[1]
        }`;
        const secondClosing = isSat ? '5 PM' : '6 PM';

        message.body = 'Open';
        message.time = [];

        if (firstClosing !== '8 AM') {
          message.time.push(`8 AM - ${firstClosing}`);
        }

        if (secondOpening !== secondClosing) {
          message.time.push(`${secondOpening} - ${secondClosing}`);
        }
      }
    } else {
      const nextDayOfWeek = format(nextDay?.formattedDate || '', 'dddd');
      message.intro = 'CLOSED';
      message.body = ` - Open ${nextDayOfWeek} at`;
      message.time = nextDay?.openingTime?.formattedHour;
    }
  }
  return (
    <p styleName="container">
      {message.intro && <span styleName="closed">{message.intro}</span>}
      {message.body}
      {Array.isArray(message.time) ? (
        <span className="hours-msg-times">
          <span styleName="time">{message.time[0]}</span>
          {message.time[1] && `and`}
          {message.time[1] && <span styleName="time">{message.time[1]}</span>}
        </span>
      ) : (
        <span styleName="time">{message.time}</span>
      )}
    </p>
  );
}

StoreHoursMessage.propTypes = {
  currentTime: PropTypes.string,
  weekDays: PropTypes.arrayOf(
    PropTypes.shape({
      closingTime: PropTypes.shape({
        formattedHour: PropTypes.string,
        hour: PropTypes.number,
        minute: PropTypes.number
      }),
      formattedDate: PropTypes.string,
      openingTime: PropTypes.shape({
        formattedHour: PropTypes.string,
        hour: PropTypes.number,
        minute: PropTypes.number
      })
    })
  )
};

export default StoreHoursMessage;
